import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-terms',
  templateUrl: './customer-terms.html',
  styleUrls: ['./customer-terms.scss']
})
export class CustomerTermsComponent {}
